import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numberArrayGenerator from 'number-array-generator';
import Helmet from 'react-helmet';
import MenuItem from 'material-ui/MenuItem';
import { Link } from 'react-router';
import AutoComplete from 'material-ui/AutoComplete';
import Paper from 'material-ui/Paper';
import AdBlockDetect from 'react-ad-block-detect';
import cookie from 'js-cookie';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';
import { generateFacebookTargetingSpec } from '../../../helpers/facebookAdTargeting';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import DropDownMenu from 'material-ui/DropDownMenu';
import TextField from 'material-ui/TextField';
import { Accordion, AdStep2Preview, ButtonBar, FormSection, PageHeader, MultiAccordionSection, SecondaryButton } from 'components';
import { connect } from 'react-redux';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';
import RaisedButton from 'material-ui/RaisedButton';
import { addNewCustomConsent, setCustomConsentText, setCustomConsentRequired, removeCustomConsent } from 'redux/modules/adBuilder';
import Checkbox from 'material-ui/Checkbox';
import * as styles from './style.scss';
var ThankYou = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    adAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null,
    formValues: state.form["adForm_".concat(orgId)] ? state.form["adForm_".concat(orgId)].values : {},
    theme: state.theme
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ThankYou, _Component);

  var _super = _createSuper(ThankYou);

  function ThankYou() {
    _classCallCheck(this, ThankYou);

    return _super.apply(this, arguments);
  }

  _createClass(ThankYou, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React.createElement("section", {
        style: {
          margin: '1rem'
        }
      }, this.props.validationErrors.length > 0 && /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 50
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, "There are errors in this section.")), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("ul", null, this.props.validationErrors.map(function (e) {
        return /*#__PURE__*/React.createElement("li", {
          style: {
            color: 'red'
          }
        }, e);
      })))), /*#__PURE__*/React.createElement("small", null, "You can customize the screen your leads see after they submit the form."), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          marginTop: 20
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-2 ".concat(styles.textFieldLabel)
      }, "Headline"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-9"
      }, this.props.builder && /*#__PURE__*/React.createElement(TextField, {
        hintText: "Required",
        value: this.props.builder.thankYouHeadline,
        fullWidth: true,
        onChange: function onChange(_ref) {
          var target = _ref.target;
          return _this.props.changeField('thankYouHeadline', target.value);
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-1"
      }, 60 - (this.props.builder ? this.props.builder.thankYouHeadline.length : 0))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-2 ".concat(styles.textFieldLabel)
      }, "Description"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-10"
      }, this.props.builder && /*#__PURE__*/React.createElement(TextField, {
        hintText: "Required",
        value: this.props.builder.thankYouDescription,
        fullWidth: true,
        multiLine: true,
        rows: 2,
        rowsMax: 4,
        onChange: function onChange(_ref2) {
          var target = _ref2.target;
          return _this.props.changeField('thankYouDescription', target.value);
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          marginTop: 20
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-2 ".concat(styles.textFieldLabel)
      }, "Button Text"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-9"
      }, this.props.builder && /*#__PURE__*/React.createElement(TextField, {
        hintText: "Required",
        value: this.props.builder.thankYouButtonText,
        fullWidth: true,
        onChange: function onChange(_ref3) {
          var target = _ref3.target;
          return _this.props.changeField('thankYouButtonText', target.value);
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-1"
      }, 60 - (this.props.builder ? this.props.builder.thankYouButtonText.length : 0))), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          marginTop: 20
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-2 ".concat(styles.textFieldLabel)
      }, "Website Link"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-10"
      }, this.props.builder && /*#__PURE__*/React.createElement(TextField, {
        hintText: "Required",
        value: this.props.builder.thankYouButtonURL,
        fullWidth: true,
        onChange: function onChange(_ref4) {
          var target = _ref4.target;
          return _this.props.changeField('thankYouButtonURL', target.value);
        }
      }))));
    }
  }]);

  return ThankYou;
}(Component)) || _class);
export default ThankYou;